import axios from 'axios'
import { getToken, removeToken, getVirtualStatus } from '@/utils/auth'
import store from '@/store'
import router from '@/router'
import qs from 'qs';
import { VUE_APP_BASEURL } from '@/config'
import { MessageBox } from 'element-ui'
import i18n from '@/common/lang'

let isKickedOutDialogShowing = false

const authWhiteList = ['/pass/login', '/pass/register', '/pass/reset', '/introduction', '/api/loginCallback/google', '/ai']
function isOnWhiteListPage() {
    const path = router.currentRoute && router.currentRoute.path;
    if (!path) return false;
    return authWhiteList.some(p => path.startsWith(p));
}


// const host = window.location.hostname
const service = axios.create({
    //  baseURL: process.env.BASE_API,111.231.59.56 ,192.168.1.115
    //   baseURL: host === 'hhsaas-test.miyapay.com' ? '/api' : '',
    // baseURL: 'http://121.196.205.21:8080',
    baseURL: VUE_APP_BASEURL,
    timeout: 90000
})

service.interceptors.request.use(
    config => {
        // config.headers['type'] = 'merchant' // 类型 商户
        // config.headers['Content-Type'] = 'application/json'
        const token = getToken()
        const virtually = getVirtualStatus()
        if (token && !config.noAuth) {
            config.headers['Authorization'] = token;
        }
        if (virtually) {
            config.headers['virtually'] = virtually;
        }
        if (config.method === 'get') {
            // 如果是get请求，且params是数组类型如arr=[1,2]，则转换成arr=1&arr=2
            config.paramsSerializer = function (params) {
                return qs.stringify(params, { arrayFormat: 'repeat' })
            }
        }
        return config
    },
    error => {
        Promise.reject(error)
    }
)

service.interceptors.response.use(

    response => {
        // 单点登录：账号已在其他地方登录
        if (response.data.code == 4011) {
            // 立刻清除无效 token，防止刷新后继续触发 4011
            removeToken();
            if (!isKickedOutDialogShowing) {
                isKickedOutDialogShowing = true;
                const loginIp = response.data.loginIp || 'Unknown';
                const msg = i18n.t('Your account has been logged in from another location. Please verify.')
                    + '\n\n' + i18n.t('Login IP') + ': ' + loginIp
                    + '\n\n' + i18n.t('If this was not you, please change your password immediately.');
                MessageBox.alert(msg, i18n.t('Security Alert'), {
                    confirmButtonText: i18n.t('OK'),
                    type: 'warning',
                    showClose: false,
                    callback: () => {
                        isKickedOutDialogShowing = false;
                        store.dispatch('loginOut').then(() => {
                            const rt = require('@/router').default;
                            if (!rt.currentRoute.path.startsWith('/pass/')) {
                                rt.push('/pass/login').catch(err => {
                                    if (err.name !== 'NavigationDuplicated') {
                                        console.error('Navigation error:', err);
                                    }
                                });
                            }
                        });
                    }
                });
            }
            return { code: 4011, kickedOut: true };
        }
        if (response.data.code == 401) {
            console.log('检测到401错误，可能是token过期:', response);

            // 前置页开启或配置未加载完时首页不跳登录
            if ((store.state.landingPageEnabled === '1' || !store.state.landingConfigLoaded) && (router.currentRoute.path === '/' || router.currentRoute.path === '/home')) {
                removeToken();
                store.dispatch('loginOut');
                return response;
            }

            // 白名单页面（免登录访问）不跳转
            if (isOnWhiteListPage()) {
                return response;
            }

            // 访客模式=open 且无 token（纯访客浏览），静默处理 401
            if (store.state.visitorMode === 'open' && !getToken()) {
                return response;
            }

            // 检查是否在提现页面，如果是则显示特殊提示
            const currentPath = router.currentRoute.path;
            if (currentPath.includes('/profile/balance')) {
                MessageBox.confirm(
                    i18n.t('Login session expired. Withdrawal may fail. Re-login?'),
                    i18n.t('Session Expired'),
                    {
                        confirmButtonText: i18n.t('OK'),
                        cancelButtonText: i18n.t('Cancel'),
                        type: 'warning'
                    }
                ).then(() => {
                    removeToken();
                    store.dispatch('loginOut').then(() => {
                        if (!router.currentRoute.path.startsWith('/pass/')) {
                            router.push("/pass/login").catch(err => {
                                if (err.name !== 'NavigationDuplicated') {
                                    console.error('Navigation error:', err);
                                }
                            });
                        }
                    });
                }).catch(() => {});
            } else {
                removeToken();
                store.dispatch('loginOut').then(() => {
                    if (!router.currentRoute.path.startsWith('/pass/')) {
                        router.push("/pass/login").catch(err => {
                            if (err.name !== 'NavigationDuplicated') {
                                console.error('Navigation error:', err);
                            }
                        });
                    }
                });
            }
            return response;
        }
        if (response.status !== 200) {
            // message.error('网络错误....')
        } else {
            if (response.data.code == '999') {
                // message.error(response.data.msg);
            }
            // 下载文件用
            if (response.request && response.request.responseType === 'blob') {
                return response;
            }
            return response.data
        }
    },
    error => {
        if (error.code) {
            // message.error('网络超时....')
        }
        // 错误处理
        if (error.response && error.response.data) {
            if (error.response.status === 401) {
                console.log('网络请求401错误:', error.response);

                // 前置页开启或配置未加载完时首页不跳登录
                if ((store.state.landingPageEnabled === '1' || !store.state.landingConfigLoaded) && (router.currentRoute.path === '/' || router.currentRoute.path === '/home')) {
                    removeToken();
                    store.dispatch('loginOut');
                    return Promise.reject(error);
                }

                // 白名单页面（免登录访问）不跳转
                if (isOnWhiteListPage()) {
                    return Promise.reject(error);
                }

                // 访客模式=open 且无 token（纯访客浏览），静默处理 401
                if (store.state.visitorMode === 'open' && !getToken()) {
                    return Promise.reject(error);
                }

                const currentPath = router.currentRoute.path;
                if (currentPath.includes('/profile/balance')) {
                    MessageBox.confirm(
                        i18n.t('Login session expired. Withdrawal may fail. Re-login?'),
                        i18n.t('Session Expired'),
                        {
                            confirmButtonText: i18n.t('OK'),
                            cancelButtonText: i18n.t('Cancel'),
                            type: 'warning'
                        }
                    ).then(() => {
                        if (!router.currentRoute.path.startsWith('/pass/')) {
                            router.push('/pass/login').catch(err => {
                                if (err.name !== 'NavigationDuplicated') {
                                    console.error('Navigation error:', err);
                                }
                            });
                        }
                        localStorage.clear();
                    }).catch(() => {});
                } else {
                    // 其他页面正常处理401错误
                    if (!router.currentRoute.path.startsWith('/pass/')) {
                        router.push('/pass/login').catch(err => {
                            if (err.name !== 'NavigationDuplicated') {
                                console.error('Navigation error:', err);
                            }
                        });
                    }
                    localStorage.clear();
                }

            } else if (error.response.status === 403) {
                // message.error(Object.values(error.response.data.message))
            } else {
                // message.error(Object.values(error.response.data))
            }
        }

        return Promise.reject(error)
    }
)

export default service